import { FormTextInputReadOnly } from '../text-input/FormTextInputReadOnly'

export const FormNumericInputPrint = (props) => {
  return <FormTextInputReadOnly {...props} />
}
